import React, { useState } from "react";
import Viewer from "react-viewer";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import Loader from "../../../components/Loader";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import { useGetCsrGalleryApiQuery } from "../../../redux/services/apiHome";

const PhotoGalleryCSR = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();
  const [visible, setVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);
  const {
    data: csrPhotoGalleryData = [],
    isLoading: csrPhotoGalleryIsLoading,
  } = useGetCsrGalleryApiQuery({
    url: languageType === "hi" ? `csr-photo?lang=${languageType}` : `csr-photo`,
  });

  const openViewer = (images, index) => {
    setCurrentImages(images.map((img) => ({ src: img.url, alt: img.title })));
    setActiveIndex(index);
    setVisible(true);
  };

  if (csrPhotoGalleryIsLoading) {
    return (
      <div className="csr-loader">
        <Loader />;
      </div>
    );
  }

  return (
    <>
      <h2 className="title2">{getText("Photo Gallery", "फोटो गैलरी")}</h2>
      <div className="container">
        {csrPhotoGalleryData.map((galleryItem, index) => (
          <div className="row" key={index}>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 wow zoomIn">
              <div className="title-sec mb-2">
                <h2>{galleryItem.title}</h2>
              </div>
            </div>
            {galleryItem.images.length > 0 &&
              galleryItem.images.map((item, subIndex) => (
                <div
                  className="col-12 col-sm-12 col-md-4 col-lg-4 mb-4 print-gallery3"
                  key={subIndex}
                  onClick={() => openViewer(galleryItem.images, subIndex)}
                >
                  <div>
                    <div className="card-sec wow zoomIn csr-title">
                      <div className="img-sec">
                        <img alt="" src={item.url} />
                      </div>
                      <div className="desc-sec csr-gallery-desc">
                        <div className="title-sec">
                          <h4>
                            <a
                              href="javascript:void(0)"
                              className="line-clamp line-clamp-2"
                            >
                              {item.title}
                            </a>
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        ))}
      </div>
      <PageLastUpdated lastUpdatedOn={csrPhotoGalleryData[0].changed} />

      <Viewer
        visible={visible}
        onClose={() => setVisible(false)}
        onMaskClick={() => setVisible(false)}
        images={currentImages}
        activeIndex={activeIndex}
        rotatable={false}
        zoomable={true}
        scalable={false}
        drag={false}
        // downloadable={true}
      />
    </>
  );
};

export default PhotoGalleryCSR;
